export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=005b4c2643468e8cb155b17d0a8676eef381f6c6ae&name=fetchPublisherData!'